module.exports = __webpack_public_path__ + "img/sharp-example1.541817ca.jpg";